import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import VaccinationRequestDetails from './modals/VaccinationRequestDetails';
import LoadingComponent from '../common/LoadingComponent';
import { getVaccinationRequest } from '../../services/api/cashless-vaccination';

const VaccinationRequestDetailsWrapper = () => {
    const { reqId } = useParams(); // Extract the reqId from the route
    const [details, setDetails] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        if (reqId) {
            getVaccinationRequest(reqId)
                .then((response) => {
                    if (response) {
                        setDetails({
                            requestId: reqId,
                            showRequestDetails: true,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error fetching request details:', error);
                    toast.error('Failed to fetch vaccination request details.');
                    history.push('/'); // Redirect to home or a fallback route
                })
                .finally(() => setIsLoading(false));
        }
    }, [reqId, history]);

    if (isLoading) {
        return <LoadingComponent color="black" />;
    }

    return (
        <VaccinationRequestDetails
            details={details}
            isOpen={true}
            onClose={() => history.push('/')} // Close and redirect back to home
        />
    );
};

export default VaccinationRequestDetailsWrapper;
